export default "__VITE_ASSET__5c56ef4d__"